var t = /* @__PURE__ */ ((e) => (e.RIGHT = "right", e.LEFT = "left", e.NONE = "none", e))(t || {});
export {
  t as e
};
